export type Kind = 'place-mappings' | 'hotel-memberships';
export interface SelectionRow {
  geo_place_id: string;
  geo_place_name: string;
  enabled: boolean;
  version: number;
  updated_at: string;
  source?: string;
  place_id?: string;
  hotel_id?: string;
  hotel_display_name?: string;
  rank?: number;
}
export interface SelectionPage {
  data: SelectionRow[];
  meta: { count: number; limit: number; offset: number; has_more: boolean };
}
export function editPayload(kind: Kind, row: SelectionRow, enabled: boolean, rank: number, reason: string) {
  const common = { geo_place_id: row.geo_place_id, enabled, expected_version: row.version, reason: reason.trim() };
  return kind === 'place-mappings'
    ? { ...common, source: row.source, place_id: row.place_id }
    : { ...common, hotel_id: row.hotel_id, rank };
}
export function isSelectionConflict(error: unknown) {
  return (error as { response?: { status?: number } })?.response?.status === 409;
}
